import './LoadingDots.scss';

export function LoadingDots() {
  return (
    <span className="LoadingDots">
      <span />
      <span />
      <span />
    </span>
  );
}
